<script lang="ts">
  import { pageHydrated } from '$lib/stores/loadStatus';
  import { blur, fade } from 'svelte/transition';
  import Wordmark from '$components/Logos/Wordmark.svelte';
</script>

{#if !$pageHydrated}
  <!-- Delay in this action is used to not hide the cover before background is done drawing. While this
  solution is a working one we may be wasting some ms here which could impact our LCP. -->
  <div class="cover" out:fade={{ delay: 800, duration: 1000 }}>
    <div
      out:blur|global={{ delay: 400, duration: 600 }}
      class="logo-container"
      data-testid="loader-logo"
    >
      <Wordmark />
    </div>
  </div>
{/if}

<style lang="scss">
  .cover {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100vw;
    height: 100%;
    height: var(--vh);
    background: #fff;
    z-index: 10000;
    display: grid;
    grid-template-columns: 1fr minmax(min-content, 90vw) 1fr;
    grid-template-rows: 1fr min-content 1fr;
    cursor: progress;

    .logo-container {
      grid-area: 2/2/3/3;
      justify-self: center;
    }
  }
</style>
